import { INITIAL_OPTION } from '@constants/index';

// option 가공
const setOption = (options?: IOption) => {
    let newOption = options && typeof options === 'object' ? {...INITIAL_OPTION, ...options} : {...INITIAL_OPTION};

    if(newOption?.communityApi) {
        newOption.communityApi = newOption.communityApi.replace(/\/+$/, '');
    }
    if(newOption?.path) {
        newOption.path = newOption.path.replace(/\/+$/, '');
    }

    return newOption;
};

let calcOption: IOption | null = null;

export const useOption = (option?: IOption) => {
    if(!calcOption) {
        calcOption = setOption(option);
    }
    return calcOption;
};